import { DataSourceExtension } from '../filters/types';

export const COLUMN_INPUT_WIDTH = '9rem';

export type FilterExtensionProps<T = string | string[]> = {
	setValue: (value: T) => void;
	value?: T;
	filterParams?: unknown; // stringified JSON filterparams (i.e. min or max value you can select)
	dataSource?: DataSourceExtension;
};

export type SelectMeta = {
	colourCoded: boolean;
	options?: { label: string; id: string; colour?: string }[];
	allowMulti: boolean;
};

export type TreeSelectData = {
	label: string;
	selectable: boolean;
	value: string;
	children: TreeSelectData[];
};
export type TreeSelectMeta = {
	allowMulti: boolean;
	data: TreeSelectData[];
};

type Link = {
	id: string;
	type: string;
};

export type LinkFilterMeta = {
	entity: Link;
	extraDetails: string;
	image: string;
	name: string;
};
